<template>
    <div class="card">

        <div class="bg-blue-light p-1">
            <TitleButton
                btnTitle="Add New"
                :showBtn="false"
                :showAddNew="false"
                :title="'Beneficiary Dashboard'"
            >
            </TitleButton>
        </div>

        <div class="p-2">
            <ul class="nav nav-tabs custom-nav-tab">
                <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                    <a
                        :class="['nav-link', { active: activeTab.id == tab.id }]"
                        @click="setActiveTab(tab)"
                    >
                      {{ tab.title }}
                    </a>
                </li>
            </ul>
        </div>

        <div v-if="activeTab.id === 'overview'" class="row justify-content-center p-1">
            <Overview />
        </div>

        <div v-if="activeTab.id === 'recent_activity'" class="row justify-content-center p-1">
            <RecentActivity />
        </div>

        <div v-if="activeTab.id === 'all_list'" class="row justify-content-center p-1">
          <AllList />
        </div>
    </div>

    <Loader v-if="loading" />
</template>

<script setup>
import TitleButton from '@/components/molecule/company/crm/visit-plan/VisitTitle.vue';
import Overview from '@/components/molecule/company/beneficiary/dashboard/Overview.vue';
import RecentActivity from '@/components/molecule/company/beneficiary/dashboard/RecentActivity.vue';
import AllList from '@/components/molecule/company/beneficiary/dashboard/AllList.vue';
import { computed, inject, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from "@/components/atom/LoaderComponent.vue";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const loading = ref(false);

const tabs = computed(() => {
    return [
        { id: 'overview', title: 'Overview' },
        { id: 'recent_activity', title: 'Recent Activity' },
        { id: 'all_list', title: 'All List' },
    ];
});

const activeTab = ref(
    tabs.value.find(t => t.id === route.query.tab) || tabs.value[0]
);

const setActiveTab = (tab) => {
    activeTab.value = tab;

    router.replace({
        query: {
            ...route.query,
            tab: tab.id
        }
    });
};

</script>

<style scoped>
.mr-25 {
  margin-right: 25px;
}
.mr-top-1 {
    margin-top: 1% !important;
}
.filter-label {
    padding-right: 0.5rem !important;
}
.custom-nav-tab{
  margin: 0 !important;
}
.custom-nav-tab .nav-item{
  font-size: 20px !important;
}

.custom-nav-tab .nav-item .active{
   font-weight: bold !important;
}
</style>